export enum FORM_MODES {
    add = 'add',
    edit = 'edit',
    clone = 'clone',
    detail = 'detail',
    delete = 'delete',
    review = 'review'
};
